import { Button } from "@/components/ui/button";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

export const NotFoundPage = () => {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col items-center justify-center min-h-[80vh] px-4 text-center">
      <div
        className="mb-8 text-7xl select-none md:text-8xl"
        role="img"
        aria-label="Megaphone"
      >
        📣
      </div>

      <h1 className="mb-4 text-3xl font-bold leading-tight whitespace-pre-line text-primary md:text-4xl">
        {t("notFound.title")}
      </h1>

      <p className="mb-10 max-w-md text-muted-foreground">
        {t("notFound.description")}
      </p>

      <Button asChild size="lg" className="px-8 rounded-xl">
        <Link to="/">{t("notFound.backToHome")}</Link>
      </Button>
    </div>
  );
};

export default NotFoundPage;
